import { IChartEventBadgeProps } from '../../../utils/chart-events-utils'
import { getChartEventEarningSvgString } from './earnings'

export function getChartEventEarningsFutureSvgString(args: IChartEventBadgeProps) {
  return getChartEventEarningSvgString({ ...args, isFuture: true })
}
